import _ from 'lodash';
import request from 'superagent';
import Immutable from 'immutable';
import { receiveError as receivePacerError } from './pacerSearch';
import * as constants from '../../constants/irSearchConstants';
import * as errorConstants from '../../constants/errorConstants';
import * as docketsConstants from '../../constants/docketsConstants';


function mapResponseToData(response, filters, searchType) {
  // todo check if other case menus return multiple types back like assoc cases
  let data = {};

  if (filters.type === 'associated_cases') {
    data = Array.isArray(response.body.queries)
      ? _.get(response.body, 'queries[0]', [])
      : _.get(response.body, 'queries', []);

    data = Object.keys(data).reduce((accum, next) => {
      accum.push([next, data[next][0].text]);
      return accum;
    }, []);
  } else {
    const type = searchType || filters.type;

    data = Array.isArray(response.body.queries)
      ? _.get(response.body, `queries[0].${type}[0].text`, [])
      : _.get(response.body, `queries.${type}[0].text`, []);
  }

  return data;
}

function mapResponseErrorsToMessage(err) {
  const request_id = _.get(err, ['response', 'body', 'error', 'request_id']);
  const errorMessageExtra = request_id
    ? `When contacting support, please quote Request ID '${request_id}'`
    : '';

  return {
    // We want to hide real messages from user since traces are confusing to them
    // TODO: coordinate with API to surface proper errors such as field validation?
    messages: [
      'PACER is experiencing some issues. Please try again in a few minutes.',
      errorMessageExtra,
    ],
    // but we include the real message in the details so we receive it in the sentry report
    details: _.get(err, ['response', 'body', 'error']) || [],
  };
}

function requestCaseData(params, dispatch) {
  dispatch({
    type: constants.REQUEST_CASE_DATA,
    params,
  });

  dispatch({
    type: constants.RESET_SERVICE_ERROR,
  });
}

function getDocketHeadersFromResp(response) {
  const docketHeadersObj = _.find(response.body.items, 'docket_headers') || {};
  const docketHeaders = (docketHeadersObj.docket_headers.length > 0)
    ? docketHeadersObj.docket_headers[0]
    : docketHeadersObj.docket_headers;

  const headersObj = _.find(response.body.items, 'headers') || {};
  const headers = (headersObj.headers.length > 0)
    ? headersObj.headers[0]
    : headersObj.headers;

  const dateFiled = (headers.text)
    ? headers.text.date_filed
    : null;

  const data = { ...docketHeaders, dateFiled };
  return { headers: data };
}

function getDocketsFromResp(response, sort_direction, selectedPageNum) {
  const dockets = response.body;
  dockets.entries = dockets.json_data || [];

  let showMissingDockets = false;

  // if there are any missing dockets for the case, show the missing dockets panel
  if (dockets.missing_docket_entries !== 'undefined' && dockets.missing_docket_entries.length > 0)
    showMissingDockets = true;

  const m = dockets.entries.reduce((accum, next, itemsIdx) => {
    switch (next.type) {
      case "DOCKET": {
        // push docket
        accum.push(next);
        break;
      }
      case "MISSING_DOCKET": {
        // push missing range entry
        accum.push({ missing: next.missing })
        break;
      }
      default: {
        console.error("Invalid docket entry type: ", next.type);
        break;
      }
    }

    return accum;
  }, []);

  delete dockets.json_data;

  dockets.entries = m;
  dockets.showMissingDockets = showMissingDockets;

  return dockets;
}

function receiveCaseDataPurchased(response, filters) {
  const data = mapResponseToData(response, filters);

  return {
    type: constants.RECEIVE_CASE_DATA,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []), // old
    lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
    receipt: _.get(response.body, 'items.receipts[0].text'),
  };
}

function receiveCaseDataLocal(response, filters) {
  const data = mapResponseToData(response, filters);

  return {
    type: constants.RECEIVE_CASE_DATA,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []),
    lastUpdated: _.get(response.body, `queries[0].${filters.type}[0].meta.timestamp`),
    receipt: null,
  };
}

function updateHasMoreRecentFilingDate(response) {
  const { docket_headers = {} } = _.find(response.body.items, 'docket_headers') || {};
  const { meta = {} } = _.find(docket_headers, 'meta') || {};
  const hasMoreRecentFilingsDate = (parseInt(meta.latest_docket_number, 10) < parseInt(meta.latest_history_number, 10))
    ? meta.latest_known_date_filed
    : null;

  return {
    type: docketsConstants.UPDATE_DOCKET_HEADER,
    docketHeader: { hasMoreRecentFilingsDate },
  };
}

function receiveError(err, msg) {
  return {
    type: constants.SERVICE_ERROR,
    error: msg,
    errors: msg,
  };
}

function onFailure(dispatch) {
  return function (err) {
    return dispatch(receiveError(constants.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
  };
}

export const checkClientCodeValid = () => function (dispatch) {
  if (!window.client_code_is_valid()) {
    dispatch(receivePacerError(
      errorConstants.VALIDATION_ERROR,
      { messages: ['Please set a valid client code first.'] },
    ));
    return;
  }
  dispatch({
    type: errorConstants.RESET_VALIDATION_ERROR,
  });
  return true;
}

export const getCaseData = params => function (dispatch) {
  requestCaseData(params, dispatch);
  dispatch({
    type: docketsConstants.UPDATE_DOCKET_HEADER,
    docketHeader: { hasMoreRecentFilingsDate: null },
  });

  return request
    .post('/ir-search/query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        dispatch(updateHasMoreRecentFilingDate(response));
        dispatch(receiveCaseDataLocal(response, params));
      },
      onFailure(dispatch),
    );
};

export const purchaseCaseData = params => function (dispatch) {
  requestCaseData(params, dispatch);

  return request
    .post('/ir-search/pacer-query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        window.refresh_menu(params.case_uuid);

        if (!_.isEmpty(response.body.error)) {
          return onFailure(dispatch)({ response });
        }

        return dispatch(receiveCaseDataPurchased(response, params));
      },
      onFailure(dispatch),
    );
};

export const getDockets = (
  headerParams,
  itemParams,
  sort_direction,
  selectedPageNum,
  receipts = {},
) => function (dispatch) {
  requestCaseData(headerParams, dispatch);

  dispatch({
    type: docketsConstants.UPDATE_DOCKET_HEADER,
    docketHeader: { hasMoreRecentFilingsDate: null },
  });

  const headerQs = {
    query: 'docket_headers',
    ...headerParams,
  };

  const headersSearch = request
    .post('/ir-search/query-json?')
    .query(headerQs)
    .set('Accept', 'application/json');

  const itemQs = {
    date_from: '_',
    date_to: '_',
    doc_range: '_',
    keyword: '_',
    page: 0,
    page_index: 1,
    sort_direction: 'desc',  // TODO THIS!!!!
    sort_field: 'date_filed',
    ...itemParams,
  };

  if (itemQs.date_from && itemQs.date_from.includes('/')) {
    const from = itemQs.date_from.split('/');
    itemQs.date_from = from[2] + '-' + from[0] + '-' + from[1];
  }

  if (itemQs.date_from && itemQs.date_to.includes('/')) {
    const to = itemQs.date_to.split('/');
    itemQs.date_to = to[2] + '-' + to[0] + '-' + to[1];
  }

  const docketsSearch = request
    .post('/dockets/search')
    .query(itemQs)
    .set('Accept', 'application/json');

  return Promise.all([headersSearch, docketsSearch])
    .then(
      (response) => {
        if (!Array.isArray(response) || response.length < 2) {
          // this should never actually happen
          return onFailure(dispatch)('missing data');
        }

        if (!_.isEmpty(response[0].body.error)) {
          return onFailure(dispatch)({ response: response[0] });
        }

        if (!_.isEmpty(response[1].body.error)) {
          return onFailure(dispatch)({ response: response[1] });
        }

        const [headersResp, docketsResp] = response;

        dispatch(updateHasMoreRecentFilingDate(headersResp));

        const headers = getDocketHeadersFromResp(headersResp);
        const dockets = getDocketsFromResp(docketsResp, sort_direction, selectedPageNum);

        const data = { ...headers, ...dockets };
        const d = Object.keys(data).reduce((accum, next) => {
          accum.push([next, data[next]]);
          return accum;
        }, []);

        dispatch({
          type: constants.RECEIVE_CASE_DATA,
          data_type: 'dockets',
          data: d,
          lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp') || receipts.lastUpdated,
          receipt: _.get(response.body, 'items.receipts[0].text') || receipts.receipt,
        });
      },
      onFailure(dispatch),
    );
};

export const getDocketDetails = (params) => function (dispatch, getState) {
  requestCaseData({}, dispatch);
  const m = getState();
  const { case_uuid, seqNum } = params;

  return request
    .get(`/ir-documentselect-json/${case_uuid}/${seqNum}`)
    .set('Accept', 'application/json')
    .then(
      (response) => {
        if (response.body && !_.isEmpty(response.body.error)) {
          return onFailure(dispatch)({ response });
        }
        let data = m.toJS().irSearch.data;

        // add the property to color the docket number correctly
        const keys = data.map(p => p[0]);
        if (_.includes(keys, 'docketDetails')) {
          data = data.map(p => {
            if (p[0] === 'docketDetails') {
              return [
                'docketDetails',
                {
                  details: response.body || [],
                  seqNum,
                },
              ];
            }
            return p;
          });
        } else {
          data.push([
            'docketDetails',
            {
              details: response.body || [],
              seqNum,
            },
          ]);
        }

        dispatch({
          type: constants.RECEIVE_CASE_DATA,
          data_type: 'dockets',
          data,
          lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
          receipt: _.get(response.body, 'items.receipts[0].text'),
        });
      },
      onFailure(dispatch),
    );
}

export const purchaseDockets = (
  params,
  selectedPageNum,
  calledFromUpdate = false,
) => function (dispatch) {
  requestCaseData(params, dispatch);

  return request
    .post('/ir-search/pacer-query-json')
    .query(params)
    .set('Accept', 'application/json')
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error)) {
          return onFailure(dispatch)({ response });
        }

        if (_.isEmpty(_.get(response.body, 'items.receipts'))) {
          // if missing receipt, something is wrong (copied from old dockets.js)
          const errMsg = {
            messages: [
              `There was an error updating the docket because the Court's website could not be accessed.  
              Please try again in a few minutes. 
              
              \nPress "clear" above or refresh your browser to dismiss this message`,
            ],
            details: [],
          };

          return dispatch({
            type: constants.SERVICE_ERROR,
            error: errMsg,
            errors: errMsg,
          });
        }

        window.refresh_menu(params.case_uuid);

        const headerParams = {
          case_uuid: params.case_uuid,
        };

        const alwaysShowFullDocketAfterUpdate = _.includes(window.Drupal.settings.always_show_full_docket_after_update || [], 'yes');

        // the chained 'search' needs to override whatever params are used for pacer search
        const itemParams = {
          case_uuid: params.case_uuid,
          date_from: (calledFromUpdate && !alwaysShowFullDocketAfterUpdate) ? params.date_from : '_',
          date_to: '_',
          doc_range: '_',
          keyword: '_',
          page: 0,
          page_index: 1,
          sort_direction: 'desc',
          sort_field: 'date_filed',
        };


        const receipts = {
          receipt: _.get(response.body, 'items.receipts[0].text'),
          lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
        }

        return getDockets(
          headerParams,
          itemParams,
          params.sort_direction,
          selectedPageNum,
          receipts,
        )(dispatch);
      },
      onFailure(dispatch),
    );
};

export const loadFavoriteEmails = (params = null) => function (dispatch, getState) {
  const m = getState();

  return request
    .get('/ir-documentselect/load_favourite_emails')
    .set('Accept', 'application/json')
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error) || response.body.success < 1) {
          return onFailure(dispatch)({ response });
        }
        const { data, lastUpdated, receipt } = m.toJS().irSearch;
        data.push([
          'favoriteEmail',
          response.body.email,
        ]);

        dispatch({
          type: constants.RECEIVE_CASE_DATA,
          data_type: 'dockets',
          data,
          lastUpdated,
          receipt,
        });

        dispatch({
          type: docketsConstants.DOCKETS_FAVORITE_EMAIL,
          favoriteEmail: { email: response.body.email, status: 'done' },
        });
      },
      onFailure(dispatch),
    );
}

function batch(url, id, dispatch, getState, step = 1) {
  return request
    .post(`${url}&op=do`)
    .set('Accept', 'application/json')
    .then(
      response => {
        const { percentage = 0 } = response.body;

        const state = getState().toJS();

        const purchased = (step === 2)
          ? state.dockets.docketParts.purchased + 1
          : state.dockets.docketParts.purchased;

        const docketParts = {
          ...state.dockets.docketParts,
          percentage,
          purchased,
        };

        dispatch({
          type: docketsConstants.UPDATE_DOCKETS_PARTS,
          docketParts,
        });


        if (percentage !== 100) {
          return batch(url, id, dispatch, getState, step);
        }
        return Promise.resolve({ ...response.body, id });
      },
      onFailure(dispatch),
    );
}

export const buyAllParts = (params) => function (dispatch, getState) {
  params = { ...params };

  const prevDocketParts = getState().toJS().dockets.docketParts;

  dispatch({
    type: docketsConstants.UPDATE_DOCKETS_PARTS,
    docketParts: {
      ...prevDocketParts,
      status: 'loading',
      step: 2,
      percentage: 0,
    },
  });

  return request.post('/dockets/buy-all-parts')
    .type('form')
    .send(parsePurchaseParams(params))
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error) || _.isEmpty(response.body.url)) {
          return onFailure(dispatch)({ response });
        }
        return batch(response.body.url, response.body.id, dispatch, getState, 2);
      },
      onFailure(dispatch),
    )
    .then(
      (batchResponse) => {
        return request
          .get(`/irbatch/finish?id=${batchResponse.id}`)
          .set('Accept', 'application/json')
          .then(
            (resp) => {
              const { data } = getState().toJS().irSearch;

              dispatch({
                type: constants.RECEIVE_CASE_DATA,
                data_type: 'dockets',
                data,
              });

              return Promise.resolve({ ...resp.body.results[0], id: batchResponse.id });
            },
            onFailure(dispatch),
          );
      },
      onFailure(dispatch),
    );
}

function parsePurchaseParams(params) {
  // clone it since we mutate it
  let newParams = { ...params };

  let docketNums = newParams.docket_numbers;

  if (Array.isArray(docketNums)) {
    delete newParams.docket_numbers;
    docketNums = docketNums.reduce((accum, next, i) => {
      accum += `&docket_numbers[]=${next}`;
      return accum;
    }, '');

    newParams = Object.keys(newParams).reduce((accum, next, i) => {
      if (i === 0) {
        accum = `${next}=${newParams[next]}`;
      } else {
        accum += `&${next}=${newParams[next]}`;
      }
      return accum;
    }, '');

    newParams += docketNums;
  }
  return newParams;
}

export const emailPdfCombined = (params) => function (dispatch, getState) {
  const { dockets } = getState().toJS();

  dispatch({
    type: docketsConstants.UPDATE_DOCKETS_PARTS,
    docketParts: {
      ...dockets.docketParts,
      status: 'loading',
      step: 3,
    },
  });

  return request
    .post('/dockets/email-pdf-combined')
    .type('form')
    .send(parsePurchaseParams(params))
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error) || _.isEmpty(response.body.url)) {
          return onFailure(dispatch)({ response });
        }
        return batch(response.body.url, response.body.id, dispatch, getState, 3);
      },
      onFailure(dispatch),
    )
    .then(
      (batchResponse) => {
        return request
          .get(`/irbatch/finish?id=${batchResponse.id}`)
          .set('Accept', 'application/json')
          .then(
            (resp) => {
              const { success, errors, link, pretty_name } = resp.body.results[0];

              dispatch({
                type: docketsConstants.DOCKETS_POPUP,
                popup: {
                  ...dockets.popup,
                  show: false,
                  data: {},
                },
              });

              dispatch({
                type: docketsConstants.UPDATE_DOCKETS_PARTS,
                docketParts: {
                  ...dockets.docketParts,
                  email_address: params.email_address,
                  step: 3,
                  link,
                  success,
                  showFlash: true,
                },
              });

              dispatch({
                type: docketsConstants.DOCKETS_FAVORITE_EMAIL,
                favoriteEmail: {
                  ...dockets.favoriteEmail,
                  status: 'done',
                },
              });

              if (params.docket_numbers && params.docket_numbers.length === 1) {
                return getDocketDetails({
                  case_uuid: params.case_uuid,
                  seqNum: params.docket_numbers[0],
                })(dispatch, getState);
              }

              return Promise.resolve('success');
            },
            onFailure(dispatch),
          );
      },
      onFailure(dispatch),
    );
}

export const downloadPdfZip = (params) => function (dispatch, getState) {
  const prevDocketParts = getState().toJS().dockets.docketParts;
  const prevPopup = getState().toJS().dockets.popup;

  dispatch({
    type: docketsConstants.UPDATE_DOCKETS_PARTS,
    docketParts: {
      ...prevDocketParts,
      status: 'loading',
      step: 3,
    },
  });

  return request
    .post('/dockets/download-pdfs-zip')
    .type('form')
    .send(parsePurchaseParams(params))
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error) || _.isEmpty(response.body.url)) {
          return onFailure(dispatch)({ response });
        }
        return batch(response.body.url, response.body.id, dispatch, getState, 3);
      },
      onFailure(dispatch),
    )
    .then(
      (batchResponse) => {
        return request
          .get(`/irbatch/finish?id=${batchResponse.id}`)
          .set('Accept', 'application/json')
          .then(
            (resp) => {
              const { success, errors, link, pretty_name } = resp.body.results[0];

              const data = {
                success,
                errors,
                link,
                pretty_name,
              };

              dispatch({
                type: docketsConstants.UPDATE_DOCKETS_PARTS,
                docketParts: {
                  ...prevDocketParts,
                  email_address: params.email_address,
                  step: 3,
                  link,
                  success,
                },
              });

              dispatch({
                type: docketsConstants.DOCKETS_POPUP,
                popup: {
                  ...prevPopup,
                  data: {},
                },
              });

              window.open(link);

              if (params.docket_numbers && params.docket_numbers.length === 1) {
                return getDocketDetails({
                  case_uuid: params.case_uuid,
                  seqNum: params.docket_numbers[0],
                })(dispatch, getState);
              }

              return Promise.resolve(data);
            },
            onFailure(dispatch),
          );
      },
      onFailure(dispatch),
    );
}

export const downloadPdfCombinedZipped = (params) => function (dispatch, getState) {
  const prevDocketParts = getState().toJS().dockets.docketParts;
  const prevPopup = getState().toJS().dockets.popup;

  dispatch({
    type: docketsConstants.UPDATE_DOCKETS_PARTS,
    docketParts: {
      ...prevDocketParts,
      status: 'loading',
      step: 3,
    },
  });

  return request
    .post('/dockets/download-pdf-combined-and-zipped')
    .type('form')
    .send(parsePurchaseParams(params))
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error) || _.isEmpty(response.body.url)) {
          return onFailure(dispatch)({ response });
        }
        return batch(response.body.url, response.body.id, dispatch, getState, 3);
      },
      onFailure(dispatch),
    )
    .then(
      (batchResponse) => {
        return request
          .get(`/irbatch/finish?id=${batchResponse.id}`)
          .set('Accept', 'application/json')
          .then(
            (resp) => {
              const { success, errors, link, pretty_name } = resp.body.results[0];

              const data = {
                success,
                errors,
                link,
                pretty_name,
              };

              dispatch({
                type: docketsConstants.UPDATE_DOCKETS_PARTS,
                docketParts: {
                  ...prevDocketParts,
                  email_address: params.email_address,
                  step: 3,
                  link,
                  success,
                },
              });

              dispatch({
                type: docketsConstants.DOCKETS_POPUP,
                popup: {
                  ...prevPopup,
                  data: {},
                },
              });

              window.open(link);

              if (params.docket_numbers && params.docket_numbers.length === 1) {
                return getDocketDetails({
                  case_uuid: params.case_uuid,
                  seqNum: params.docket_numbers[0],
                })(dispatch, getState);
              }

              return Promise.resolve(data);
            },
            onFailure(dispatch),
          );
      },
      onFailure(dispatch),
    );
}

export const downloadPdfCombined = (params) => function (dispatch, getState) {
  const prevDocketParts = getState().toJS().dockets.docketParts;
  const prevPopup = getState().toJS().dockets.popup;

  dispatch({
    type: docketsConstants.UPDATE_DOCKETS_PARTS,
    docketParts: {
      ...prevDocketParts,
      status: 'loading',
      step: 3,
    },
  });

  return request
    .post('/dockets/download-pdf-combined')
    .type('form')
    .send(parsePurchaseParams(params))
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error) || _.isEmpty(response.body.url)) {
          return onFailure(dispatch)({ response });
        }
        return batch(response.body.url, response.body.id, dispatch, getState, 3);
      },
      onFailure(dispatch),
    )
    .then(
      (batchResponse) => {
        return request
          .get(`/irbatch/finish?id=${batchResponse.id}`)
          .set('Accept', 'application/json')
          .then(
            (resp) => {
              const { success, errors, link, pretty_name } = resp.body.results[0];

              const data = {
                success,
                errors,
                link,
                pretty_name,
              };

              dispatch({
                type: docketsConstants.UPDATE_DOCKETS_PARTS,
                docketParts: {
                  ...prevDocketParts,
                  email_address: params.email_address,
                  step: 3,
                  link,
                  success,
                  status: 'done',
                },
              });

              dispatch({
                type: docketsConstants.DOCKETS_POPUP,
                popup: {
                  ...prevPopup,
                  // show: true,
                  data: {},
                },
              });

              window.open(link);

              if (params.docket_numbers && params.docket_numbers.length === 1) {
                return getDocketDetails({
                  case_uuid: params.case_uuid,
                  seqNum: params.docket_numbers[0],
                })(dispatch, getState);
              }

              return Promise.resolve('success');
            },
            onFailure(dispatch),
          );
      },
      onFailure(dispatch),
    );
}

export const emailPdfsZip = (params) => function (dispatch, getState) {
  const { dockets } = getState().toJS();

  dispatch({
    type: docketsConstants.UPDATE_DOCKETS_PARTS,
    docketParts: {
      ...dockets.docketParts,
      status: 'loading',
      step: 3,
    },
  });

  return request
    .post('/dockets/email-pdfs-zip')
    .type('form')
    .send(parsePurchaseParams(params))
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error) || _.isEmpty(response.body.url)) {
          return onFailure(dispatch)({ response });
        }
        return batch(response.body.url, response.body.id, dispatch, getState, 3);
      },
      onFailure(dispatch),
    )
    .then(
      (batchResponse) => {
        return request
          .get(`/irbatch/finish?id=${batchResponse.id}`)
          .set('Accept', 'application/json')
          .then(
            (resp) => {
              const { success, link } = resp.body.results[0];

              dispatch({
                type: docketsConstants.DOCKETS_POPUP,
                popup: {
                  ...dockets.popup,
                  show: false,
                  data: {},
                },
              });

              dispatch({
                type: docketsConstants.UPDATE_DOCKETS_PARTS,
                docketParts: {
                  ...dockets.docketParts,
                  email_address: params.email_address,
                  step: 3,
                  link,
                  success,
                  showFlash: true,
                },
              });

              dispatch({
                type: docketsConstants.DOCKETS_FAVORITE_EMAIL,
                favoriteEmail: {
                  ...dockets.favoriteEmail,
                  status: 'done',
                },
              });

              if (params.docket_numbers && params.docket_numbers.length === 1) {
                return getDocketDetails({
                  case_uuid: params.case_uuid,
                  seqNum: params.docket_numbers[0],
                })(dispatch, getState);
              }

              return Promise.resolve('success');
            },
            onFailure(dispatch),
          );
      },
      onFailure(dispatch),
    );
}

export const getDocketParts = (params) => function (dispatch, getState) {
  dispatch({
    type: docketsConstants.UPDATE_DOCKETS_PARTS,
    docketParts: {
      step: 1,
      status: 'loading',
      parts: [],
    },
  });

  const state = getState().toJS();


  return request
    .post('/dockets/get-parts')
    .type('form')
    .send(parsePurchaseParams(params))
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error) || _.isEmpty(response.body.url)) {
          return onFailure(dispatch)({ response });
        }
        return batch(response.body.url, response.body.id, dispatch, getState, 1);
      },
      onFailure(dispatch),
    )
    .then(
      (batchResponse) => {
        return request
          .get(`/irbatch/finish?id=${batchResponse.id}`)
          .set('Accept', 'application/json')
          .then(
            (resp) => {
              const { parts_to_purchase, success, total_cost, user_has_credits, parts, errors } = resp.body.results[0];

              let docketParts = {
                parts_to_purchase,
                success,
                total_cost,
                user_has_credits,
                parts,
                errors,
                step: 1,
                status: 'done',
              };

              // if parts_to_purchase is 0, already purchased - move to step 2
              if (parts_to_purchase === 0) {
                docketParts.step = 2;
                docketParts.alreadyPurchased = true;
              }

              dispatch({
                type: docketsConstants.UPDATE_DOCKETS_PARTS,
                docketParts,
              });
            },
            onFailure(dispatch),
          );
      },
      onFailure(dispatch),
    );
}

export const sendEmail = params => function (dispatch, getState) {
  const oldState = getState().toJS();

  const { email_address, email_message } = params;

  const reqParams = {
    ...params,
    mailto: email_address,
    message: email_message,
  };

  delete reqParams.email_address;
  delete reqParams.email_message;

  dispatch({
    type: docketsConstants.DOCKETS_FAVORITE_EMAIL,
    favoriteEmail: {
      ...oldState.dockets.favoriteEmail,
      status: 'loading',
    },
  });

  return request
    .post('/ir-documentselect/email_pdf/docket')
    .type('form')
    .send(reqParams)
    .then(
      (response) => {
        if (_.isEmpty(response.body) || !_.isEmpty(response.body.error) || !response.body.success) {
          return onFailure(dispatch)({ response });
        }

        dispatch({
          type: docketsConstants.DOCKETS_POPUP,
          popup: {
            ...oldState.dockets.popup,
            show: false,
            data: {},
          },
        });

        dispatch({
          type: docketsConstants.UPDATE_DOCKETS_PARTS,
          docketParts: {
            ...oldState.dockets.docketParts,
            email_address: params.email_address,
            showFlash: true,
          },
        });

        dispatch({
          type: docketsConstants.DOCKETS_FAVORITE_EMAIL,
          favoriteEmail: {
            ...oldState.dockets.favoriteEmail,
            status: 'done',
          },
        });
      },
      onFailure(dispatch),
    );
}

function markEntryAsPurchased(seqNum, data) {
  data.forEach((p) => {
    const [k, v] = p;
    if (k === 'entries') {
      v.forEach((q) => {
        if (q.meta && q.meta.docket_seq && q.meta.docket_seq === seqNum) {
          q.meta.purchased = 2;
        }
      });
    }
    return [k, v];
  });
}


export const buyPdf = params => function (dispatch, getState) {
  const { case_uuid, docket_no, number } = params;

  const { irSearch } = getState().toJS();
  const idx = _.findIndex(irSearch.data, p => p[0] === 'docketDetails');
  const { data } = irSearch;

  data[idx][1].details = irSearch.data[idx][1].details.map(p => {
    if (p.number === number) {
      return { ...p, isLoading: true };
    }
    return { ...p, isLoading: false };
  });

  dispatch({
    type: constants.RECEIVE_CASE_DATA,
    data_type: 'dockets',
    data: irSearch.data,
  });

  return request
    .get(`/ir-documentselect/order/pacer/${case_uuid}/${docket_no}/${number}`)
    .set('Accept', 'application/json');
}

export const getItems = (
  itemParams,
  sort_direction,
  selectedPageNum,
) => function (dispatch, getState) {
  requestCaseData({}, dispatch);

  const itemQs = {
    date_from: '_',
    date_to: '_',
    doc_range: '_',
    keyword: '_',
    page: 0,
    page_index: 1,
    sort_direction: 'desc',
    sort_field: 'date_filed',
    ...itemParams,
  };

  if (itemQs.date_from.includes('/')) {
    const from = itemQs.date_from.split('/');
    itemQs.date_from = from[2] + '-' + from[0] + '-' + from[1];
  }

  if (itemQs.date_to.includes('/')) {
    const to = itemQs.date_to.split('/');
    itemQs.date_to = to[2] + '-' + to[0] + '-' + to[1];
  }

  const m = getState();

  return request
    .post('/dockets/search')
    .query(itemQs)
    .set('Accept', 'application/json')
    .then(
      (response) => {
        if (!_.isEmpty(response.body.error)) {
          return onFailure(dispatch)({ response });
        }

        const dockets = getDocketsFromResp(response, sort_direction, selectedPageNum);
        let d = Object.keys(dockets).reduce((accum, next) => {
          accum.push([next, dockets[next]]);
          return accum;
        }, []);

        const ds = m.toJS().irSearch.data.reduce((accum, next) => {
          accum[next[0]] = next[1];
          return accum;
        }, {});

        d.push([['headers'], ds.headers || []]);

        return dispatch({
          type: constants.RECEIVE_CASE_DATA,
          data_type: 'dockets',
          data: d,
          lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
          receipt: _.get(response.body, 'items.receipts[0].text'),
        });
      },
      onFailure(dispatch),
    );
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/irSearch.js
 **/